import Header from './components/Header';
import Hero from './components/Hero';
import RankingSection from './components/RankingSection';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import FaqSection from './components/FaqSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import MediaSection from './components/MediaSection';
import TopicsSection from './components/TopicsSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <RankingSection />
        <AppSection />
        <AboutSection />
        <IndexSection />
        <FeaturesSection />
        <FaqSection />
        <CardsSection />
        <ContactSection />
        <CarouselSection />
        <MediaSection />
        <TopicsSection />
        <UpdatesSection />
        <CommentsSection />
      </main>
      <Footer />
    </>
  );
}